<template>
  <v-container grid-list-md pt-0>
    <div style="margin-top:17rem !important" v-if="isLoading">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-layout>
    </div>
    <div class="" v-if="!isLoading && listPlantCompany.length !== 0">
      <v-layout row wrap align-center justify-center mt-1>
        <v-flex md12 xs12 sm12>
          <v-layout row wrap align-center>
            <v-flex md4 xs12 sm6 v-for="(i,index) in listPlantCompany" :key="index">
        <v-card flat color="orange" height="100">
          <v-card-text >
            <span class="title white--text">{{i.company_name}} (ต้น)</span><br>
            <v-layout row wrap justify-space-between align-end style="margin-top:-10px">
              <v-flex sm12 xs12 md12 class="pb-0">
                  <span class="display-2 white--text font-weight-bold lineheight30">{{commaSeparateNumber(i.userPlantSum)}}</span>
              </v-flex>
              <!-- <v-flex sm12 xs12 md12 style="text-align:right" class="pb-0">
                <span class="title white--text font-weight-bold" style="color:#605559 !important">จำนวนผู้ปลูก {{commaSeparateNumber(i.numberofpeople)}} ท่าน</span>
              </v-flex> -->
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="filteredList.length === 0" justify-center mt-2>
        <v-flex xs1>
          <h2>ไม่พบข้อมูล</h2>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
export default {
  data (){
    return{
      search: '',
      totalPlant: '',
      listPlant: [],
      isSort: true,
      isLoading: true,
      numberOfPeopleByTotlePlant: '',
      userRegister: '',
      listPlantCompany: []
    }
  },
  created(){
    this.isLoading = true
    this.queryCompanyStatistic()
    this.$emit('activeMenu', 'plant_company')
  },
  computed:{
    filteredList() {
      return this.listPlantCompany.filter(post => {
        return post.company_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  methods: {
    queryCompanyStatistic(){
      this.axios.post(process.env.VUE_APP_IPFLASK + '/queryCompanyStatistic').then((response) => {
        // console.log(response.data);
        this.listPlantCompany = response.data
        this.isLoading = false
      })
    },
    commaSeparateNumber(val){
      while (/(\d+)(\d{3})/.test(val.toString())){
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    },
    sort(){
      if (this.isSort){
        this.isSort = false
        return this.listPlant.sort(function(a, b) {
          return b.sumPlant - a.sumPlant
        });
      } else {
        this.isSort = true
        return this.listPlant.sort(function(a, b) {
          return a.sumPlant - b.sumPlant
        });
      }
    }
  }

}
</script>

<style scoped>
.lineheight{
  line-height: 0.65 !important;
}
.lineheight30{
  line-height: 40px !important;
}
</style>
